export class ScrapCauseDto {
    id!: number;
    text!: string;
}
